import {
    GETUPDATECOMMOMCONFDETAILSADMIN_SUCCESS,
    GETUPDATECOMMOMCONFDETAILSADMIN_FAILED,
    RESET_GETUPDATECOMMOMCONFDETAILSADMIN,
    LOADING_GETUPDATECOMMOMCONFDETAILSADMIN,
    NETWORK_GETUPDATECOMMOMCONFDETAILSADMIN,
} from "../types/index";

import { adminServices } from "../../config/axios";

const resetGetUpdateCommomConfAdmin = () => {
    return { type: RESET_GETUPDATECOMMOMCONFDETAILSADMIN };
};

const getUpdateCommomConfDetailsAdmin =
    (userData, authTokenIs) => async (dispatch) => {
        dispatch({ type: LOADING_GETUPDATECOMMOMCONFDETAILSADMIN });
        await adminServices
            .post("getUpdateCommomConfDetailsAdmin", userData, {
                headers: { AuthToken: authTokenIs },
            })
            .then((res) => {
                switch (res.data.status) {
                    case "success":
                        dispatch(getUpdateCommomConfAdminSuccess(res.data));
                        break;
                    default:
                        dispatch(getUpdateCommomConfAdminFailed(res.data));
                        break;
                }
            })
            .catch((err) => {
                dispatch({
                    type: NETWORK_GETUPDATECOMMOMCONFDETAILSADMIN,
                    payload: err,
                });
            });

        function getUpdateCommomConfAdminSuccess(data) {
            return {
                type: GETUPDATECOMMOMCONFDETAILSADMIN_SUCCESS,
                payload: data,
            };
        }

        function getUpdateCommomConfAdminFailed(data) {
            return {
                type: GETUPDATECOMMOMCONFDETAILSADMIN_FAILED,
                payload: data,
            };
        }
    };
export { resetGetUpdateCommomConfAdmin, getUpdateCommomConfDetailsAdmin };